import "./ContactConversationLink.css";

import { Button } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import { CHAT_PAGE_PATH } from "../../pages/contacts/chat/ChatPage";
import { useNavigate } from "react-router-dom";

interface ContactConversationLinkProps {
  isConversationEmpty: boolean
}

const ContactConversationLink: React.FC<ContactConversationLinkProps> = ({ isConversationEmpty }) => {
  const navigate = useNavigate();

  return (
    <div className="contact-conversation-link">
      {!isConversationEmpty && <Button
        type={"primary"}
        icon={<CommentOutlined />}
        onClick={() => navigate(CHAT_PAGE_PATH)}
      >
        Accéder à la conversation
      </Button>}
    </div>
  );
};

export default ContactConversationLink;
